import { useRef, useEffect } from 'react'
import { format } from 'date-fns'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { Slider, Rail, Handles, Tracks, Ticks } from 'react-compound-slider'
import { Handle, Track, Tick } from './RigSelectElements'
import { useLang } from '../utils/hooks'
import { langRigs } from '../assets/langRigs'
import { railStyle, sliderStyle } from './StyledElements'
import { chartColors } from '../assets/colors'

const RigsChart = ({
  chartOptions,
  timeDomain,
  sliderValues,
  handleSliderChange,
}) => {
  const oneSec = 1000
  const { lang } = useLang()
  const choosenLang = lang === 'fr' ? langRigs.fr : langRigs.eng

  const format_tick = (ms) => {
    return format(new Date(ms), 'HH:mm')
  }

  useEffect(() => {
    if (!chart.current) return
    let zones = []

    for (let i = 1; i < sliderValues.length; i++) {
      zones.push({ value: sliderValues[i], color: chartColors[i - 1].color })
    }
    chart.current.chart.series[0].update({ zones: zones })
  }, [sliderValues])

  const chart = useRef(null)
  return (
    <>
      <div className="block">
        <div style={{ width: '100%' }}>
          <HighchartsReact
            highcharts={Highcharts}
            options={chartOptions}
            ref={chart}
          />
        </div>
      </div>
      <div className="block">
        {sliderValues.length > 0 && (
          <Slider
            rootStyle={sliderStyle}
            domain={[+timeDomain[0], +timeDomain[1]]}
            step={+oneSec}
            mode={3}
            values={sliderValues}
            onChange={handleSliderChange}
          >
            <Rail>
              {({ getRailProps }) => (
                <div style={railStyle} {...getRailProps()} />
              )}
            </Rail>
            <Handles>
              {({ handles, getHandleProps }) => (
                <div className="slider-handles">
                  {handles.map((handle) => (
                    <Handle
                      key={handle.id}
                      handle={handle}
                      getHandleProps={getHandleProps}
                    />
                  ))}
                </div>
              )}
            </Handles>
            <Tracks left={false} right={false}>
              {({ tracks, getTrackProps }) => (
                <div className="slider-tracks">
                  {tracks.map(({ id, source, target }) => (
                    <Track
                      key={id}
                      source={source}
                      target={target}
                      getTrackProps={getTrackProps}
                    />
                  ))}
                </div>
              )}
            </Tracks>
            <Ticks
              count={10 /* generate approximately 10 ticks within the domain */}
            >
              {({ ticks }) => (
                <div className="slider-ticks">
                  {ticks.map((tick) => (
                    <Tick
                      key={tick.id}
                      tick={tick}
                      count={ticks.length}
                      format_tick={format_tick}
                    />
                  ))}
                </div>
              )}
            </Ticks>
          </Slider>
        )}
        {sliderValues.length === 0 && (
          <div className="notification is-alert">{choosenLang.alert}</div>
        )}
      </div>
    </>
  )
}

export default RigsChart
